import { Polygon } from 'geojson'
import Adresse from 'entity/Adresse'
import Point from 'entity/Point'

export enum TypeLocal {
  Maison = 1,
  Appartement = 2,
  Dependance = 3,
  LocalIndustrieCommerceAssimile = 4,
}

export type IdParcelle = string

export interface Local {
  type: TypeLocal
  surface: number | null
  nbPiece: number | null
  parcelle: IdParcelle
}

export enum NatureCulture {
  TerrainsABatir = 'AB',
  TerrainsAgrement = 'AG',
  Bois = 'B',
  FutaiesFeuillues = 'BF',
  FutaiesMixtes = 'BM',
  Oseraies = 'BO',
  Peupleraies = 'BP',
  FutaiesResineuses = 'BR',
  TaillisSousFutaie = 'BS',
  TaillisSimples = 'BT',
  Carrieres = 'CA',
  CheminDeFer = 'CH',
  Eaux = 'E',
  Jardins = 'J',
  Landes = 'L',
  LandesBoisees = 'LB',
  Pres = 'P',
  Patures = 'PA',
  Pacages = 'PC',
  PresEmbouche = 'PE',
  Herbages = 'PH',
  PresPlantes = 'PP',
  Sols = 'S',
  Terres = 'T',
  TerresPlantees = 'TP',
  Vergers = 'VE',
  Vignes = 'VI',
}

export interface Terrain {
  natureCulture: NatureCulture
  surface: number | null
  parcelle: IdParcelle
}

export enum NatureMutation {
  Vente = 1,
  VenteFuturAchevement = 2,
  VenteTerrainBatir = 3,
  Adjudication = 4,
  Expropriation = 5,
  Echange = 6,
}

interface AddressesIndexedByParcelleIds {
  [idParcelle: string]: Adresse
}

export type IdMutation = string

export interface Mutation {
  date: string
  adressesParcelle: AddressesIndexedByParcelleIds
  local: Local[]
  montant: number // Euros
  multiParcelle: boolean
  natureMutation: NatureMutation
  prixM2: number
  terrain: Terrain[]
}

export interface MutationsIndexedByIds {
  [idMutation: string]: Mutation
}

export interface Parcelle {
  idsMutation: IdMutation[]
  parcelleAdresse: string | null
  parcelleCentre: Point
  parcelleGeography: Polygon
  parcelleUid: IdParcelle
}

export interface Dvf {
  mutations: MutationsIndexedByIds
  parcelles: Parcelle[]
}
